import React from "react"
//import I18n from "i18n-js/index.js.erb"

class PortalReservationPresenterTabs extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div style={{position: 'relative'}}>
        <ul className="nav nav-tabs">
          <li role="presentation" className={this.props.active_tab === 'summary' ? 'active' : null}>
            <a href="#summary" onClick={this.props.onChangeActiveTab.bind(null, 'summary')}>
              {I18n.t('summary')}
            </a>
          </li>
          <li role="presentation" className={this.props.active_tab === 'transactions' ? 'active' : null}>
            <a href="#transactions" onClick={this.props.onChangeActiveTab.bind(null, 'transactions')}>
              {I18n.t('transactions')}
            </a>
          </li>
        </ul>

        <div className="print-btn" style={{position: 'absolute', top: '-2px', right: '0px'}}>
          <button className="btn btn-dark btn-sm" title={I18n.t('print')} onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.print();
          }}><span className="ss-print"></span></button>
        </div>
      </div>
    );
  }
}

export default PortalReservationPresenterTabs